/* ORIIVE — défilement des images produit au survol (cartes accueil).
   Cycle UNE passe sur les images 2..4 (800 ms/image) puis se pose sur l'image 2.
   Desktop pointer uniquement ; retour à l'image principale au mouseleave. */
(function () {
  if (window.__oriiveHoverCycle) return;
  window.__oriiveHoverCycle = true;
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var STEP_MS = 800;

  function init(media) {
    var urls = (media.getAttribute('data-cycle') || '').split('|').filter(Boolean);
    if (!urls.length) return;
    var timer = null, idx = 0, done = false, layers = [], active = -1, preloaded = false;

    function makeLayer() {
      var img = document.createElement('img');
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .3s ease;pointer-events:none;';
      media.appendChild(img);
      return img;
    }

    function show(url) {
      var next = (active + 1) % 2;
      layers[next].src = url;
      media.appendChild(layers[next]); /* passe au-dessus */
      requestAnimationFrame(function () { layers[next].style.opacity = '1'; });
      if (active >= 0) layers[active].style.opacity = '0';
      active = next;
    }

    function tick() {
      idx++;
      if (idx >= urls.length) { idx = 0; done = true; } /* fin de passe : retour image 2 et stop */
      show(urls[idx]);
      if (!done) timer = setTimeout(tick, STEP_MS);
    }

    media.addEventListener('mouseenter', function () {
      if (!preloaded) { urls.forEach(function (u) { (new Image()).src = u; }); preloaded = true; }
      if (!layers.length) layers = [makeLayer(), makeLayer()];
      clearTimeout(timer); done = false; idx = 0;
      show(urls[0]);
      if (urls.length > 1) timer = setTimeout(tick, STEP_MS);
    });

    media.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      layers.forEach(function (l) { l.style.opacity = '0'; });
      active = -1; idx = 0; done = false;
    });
  }

  function boot() {
    document.querySelectorAll('.hp2-pc__media[data-cycle]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
